// SignalR Konfiguration
export const signalRConfig = {
    // Basis-URL für SignalR Hubs
    hubUrls: {
        // Beispiel URLs - passen Sie diese an Ihre Backend-URLs an
        test: process.env.REACT_APP_serverEndpoint + '/testhub',
        scoreboard: process.env.REACT_APP_serverEndpoint + '/scoreboardhub',
        competition: process.env.REACT_APP_serverEndpoint + '/competitionhub',

    },

    // Verbindungsoptionen
    connectionOptions: {
        // Automatische Wiederverbindung aktivieren
        automaticReconnect: true,

        // Wiederverbindungsintervalle in Millisekunden
        reconnectIntervals: [0, 2000, 10000, 30000],

        // Timeout für Verbindungsaufbau
        serverTimeoutInMilliseconds: 30000,

        // Keep-Alive Intervall
        keepAliveIntervalInMilliseconds: 15000,

        // Protokoll (kann 'json', 'messagepack' sein)
        protocol: 'json',

        // Logging Level ('Critical', 'Error', 'Warning', 'Information', 'Debug', 'Trace', 'None')
        logLevel: 'Information'
    },

    // Standard Event-Namen
    events: {
        // Nachrichten Events
        receiveMessage: 'ReceiveMessage',
        // Scoreboard Events
        scoreboardUpdateHeat: 'ScoreboardUpdateHeat',
        scoreboardHeatChanged: 'ScoreboardHeatChanged',

    },

    // Error Handling
    errorHandling: {
        maxRetries: 5,
        retryDelay: 1000,
        showUserErrors: true,
        logErrors: true
    }
};

// Helper-Funktionen
export const getHubUrl = (hubName ) => {
    return signalRConfig.hubUrls[hubName] || signalRConfig.hubUrls.chat;
};

// Umgebungsspezifische Konfiguration
export const getConfig = () => {
    return signalRConfig;
};
